/*
 * theme-toggle.js
 * 右上角亮色/暗色切換按鈕。點擊切換 <html data-theme>，並以 localStorage 記住選擇。
 * 初始主題由 theme.liquid <head> 內嵌腳本決定（跟隨裝置、抓不到預設暗色），此檔只負責按鈕與切換。
 */
(function () {
  'use strict';
  var KEY = 'ct-theme';
  var SUN = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="4.2"></circle><path d="M12 2.5v2.3M12 19.2v2.3M4.2 4.2l1.6 1.6M18.2 18.2l1.6 1.6M2.5 12h2.3M19.2 12h2.3M4.2 19.8l1.6-1.6M18.2 5.8l1.6-1.6"></path></svg>';
  var MOON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 14.5A8 8 0 1 1 9.5 4a6.3 6.3 0 0 0 10.5 10.5z"></path></svg>';

  function currentTheme() {
    return document.documentElement.getAttribute('data-theme') === 'light' ? 'light' : 'dark';
  }
  function render(btn) {
    var dark = currentTheme() === 'dark';
    btn.innerHTML = dark ? SUN : MOON; // 暗色時顯示太陽(點了切亮)，亮色時顯示月亮
    var label = dark ? '切換為亮色主題' : '切換為暗色主題';
    btn.setAttribute('aria-label', label);
    btn.setAttribute('title', label);
  }
  function apply(theme) {
    document.documentElement.setAttribute('data-theme', theme);
    try { localStorage.setItem(KEY, theme); } catch (e) {}
  }
  function init() {
    var host = document.querySelector('.header__icons');
    if (!host || document.querySelector('.ct-theme-toggle')) return;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'ct-theme-toggle header__icon header__icon--summary link focus-inset';
    render(btn);
    btn.addEventListener('click', function () {
      apply(currentTheme() === 'dark' ? 'light' : 'dark');
      render(btn);
    });
    host.insertBefore(btn, host.firstChild);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
